
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"clip-rule":"evenodd","d":"M9.9 6h9l-1.3-1.3c-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0l3 3c.4.4.4 1 0 1.4l-2.9 2.9-.1.1c-.4.4-1 .4-1.4 0-.4-.4-.4-1 0-1.4L18.9 8H9.7C6.5 8.1 4 10.7 4 13.9s2.5 5.8 5.7 5.9h2.7c.6 0 1 .4 1 1s-.4 1-1 1H9.7C5.4 21.7 2 18.2 2 13.9 2 9.5 5.5 6 9.9 6zm-.475 4.682h1.156V16.5h-1.23v-4.65h-.034l-1.333.835v-1.091l1.44-.912zm7.17 2.915c-.003 1.917-.887 3.03-2.35 3.03-1.466-.002-2.355-1.118-2.35-3.03.003-1.907.89-2.995 2.35-2.995 1.457 0 2.352 1.091 2.35 2.995zm-3.447 0c-.002 1.34.43 2.011 1.097 2.011.665 0 1.097-.67 1.094-2.011 0-1.321-.432-1.986-1.094-1.986-.665 0-1.094.665-1.097 1.986z"}})])
          )
        }
      }
    